// Angular
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// Material


import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';


// RXJS
import { debounceTime, distinctUntilChanged, tap, skip, take, delay } from 'rxjs/operators';
import { fromEvent, merge, Observable, of, Subscription } from 'rxjs';
// LODASH
import { each, find } from 'lodash';
// NGRX
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../../../core/reducers';

// Services

import { LayoutUtilsService, MessageType, QueryParamsModel } from '../../../../../core/_base/crud';
import { UserService } from '../../../services/user.service';
import { MatTableDataSource } from '@angular/material/table'
// Models
import {
	User,
	Role,
	UsersDataSource,
	UserDeleted,
	UsersPageRequested,
	selectUserById,
	selectAllRoles
} from '../../../../../core/auth';
import { SubheaderService } from '../../../../../core/_base/layout';

// Table with EDIT item in MODAL
// ARTICLE for table with sort/filter/paginator
// https://blog.angular-university.io/angular-material-data-table/
// https://v5.material.angular.io/components/table/overview
// https://v5.material.angular.io/components/sort/overview
// https://v5.material.angular.io/components/table/overview#sorting
// https://www.youtube.com/watch?v=NSt9CI3BXv4
@Component({
	selector: 'kt-users-list',
	templateUrl: './users-list.component.html',
	styleUrls: ['./users-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UsersListComponent implements OnInit, OnDestroy {
	// Table fields
	//dataSource: UsersDataSource;
	dataSource = new MatTableDataSource();

	displayedColumns = ['select', 'id', 'fullname', 'username', 'email', 'role', 'actions'];
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild('sort1', { static: true }) sort: MatSort;
	// Filter fields
	@ViewChild('searchInput', { static: true }) searchInput: ElementRef;
	lastQuery: QueryParamsModel;
	// Selection
	selection = new SelectionModel<User>(true, []);
	usersResult: User[] = [];
	allRoles: Role[] = [];
	data: any = [];
	userLists: any = [];
	user: User


	// Subscriptions
	private subscriptions: Subscription[] = [];
	userName: string;
	priceStatus: string;
	role: string;
	distributorCompanyName: string;
	IsKikMember: boolean;
	userid: any;
	isDirectCustomer: boolean;
	selectedStatus: string = 'all'; // Default filter

	/**
	 *
	 * @param activatedRoute: ActivatedRoute
	 * @param store: Store<AppState>
	 * @param router: Router
	 * @param layoutUtilsService: LayoutUtilsService
	 * @param subheaderService: SubheaderService
	 */
	constructor(
		private userService: UserService,
		private activatedRoute: ActivatedRoute,
		private store: Store<AppState>,
		private router: Router,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private cdr: ChangeDetectorRef) {
		this.userService.subscribeToLogoUploaded().subscribe((logo: string) => {
			// Update user's profile picture when a new logo is uploaded
			this.user.profilePicture = logo;
		});
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {


		this.loadUsersList();
		this.priceStatus = localStorage.getItem('priceStatus');
		this.userName = localStorage.getItem('username');
		this.userid = localStorage.getItem('userId');
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
		this.userService
			.getUserById(this.userid)
			.subscribe(
				(user) => {
					this.role = user.role
					this.distributorCompanyName = user.distributorCompanyName
					this.IsKikMember = user.isKikMember
					this.isDirectCustomer = user.isDirectCustomer

				},
				(error) => {
					console.error(
						'Error fetching users by userId',
						error
					);
				}
			);
		this.userService.initSocket().subscribe(data => {
			const { userId, isActive } = data as { userId: string, isActive: boolean };
			const userToUpdate = this.dataSource.data.find((user: User) => user.uuid === userId) as User;
			if (userToUpdate) {
				userToUpdate.isActive = isActive;
				// Trigger change detection
				this.cdr.detectChanges();
			}
		});
		this.NewloadRolesList();

	}

	onStatusFilterChange(status: string) {
		this.selectedStatus = status;
		this.NewloadRolesList(); // Reload data with the applied filter
	}

	NewloadRolesList() {
		this.userService.getAllUsers().subscribe(res => {
			this.userLists = res;
			//this.dataSource.data = res;
			const data = res;
			if (this.role === 'superadmin') {
				this.dataSource.data = res.filter(user => user.email && user.username);
			}
			else {
				this.filterDataByRole(data);
			}
			// else{
			//    this.dataSource.data=res.filter(o => o.username === this.userName
			// 	   );

			// }
			this.dataSource.data = this.applyStatusFilter(data);
		})
	}
	private applyStatusFilter(users: User[]): User[] {
		if (this.selectedStatus === 'online') {
			return users.filter(user => user.isActive === true);
		} else if (this.selectedStatus === 'offline') {
			return users.filter(user => user.isActive === false || user.isActive === undefined);
		}
		return users; // Return all users if `all` is selected
	}
	private filterDataByRole(data: User[]): void {
		if (this.role === 'admin') {
			this.filterDataForAdminAndLocalUser(data);
		} else {
			this.dataSource.data = data.filter((o) => o.uuid === this.userid);
		}
	}

	/**
	 * Filter data for admin and local user
	 */
	private filterDataForAdminAndLocalUser(data: User[]): void {
		const distributorCompanyName = this.distributorCompanyName;

		if (distributorCompanyName && distributorCompanyName.length) {
			this.filterDataByDistributionCompanyName(data, distributorCompanyName);
		} else if (this.IsKikMember === true) {
			const IsKikMember = this.IsKikMember
			if (IsKikMember !== null) {
				this.filterDataByKikMembers(data, IsKikMember);
			}
		} else {
			this.dataSource.data = data.filter((o) => o.uuid === this.userid);
		}
	}

	/**
	 * Filter data by distribution company name
	 */
	private filterDataByDistributionCompanyName(
		data: User[],
		distributorCompanyName: string
	): void {
		this.userService
			.getUsersByDistributionCompanyName(distributorCompanyName)
			.subscribe(
				(users) => {
					let filteredUserId: string[] = this.getFilteredUserId(users);
					this.dataSource.data = data.filter((fillterdusers) =>
						filteredUserId.includes(fillterdusers.uuid)
					);
				},
				(error) => {
					console.error(
						'Error fetching users by distribution company name',
						error
					);
				}
			);
	}

	/**
	 * Filter data by Kik members
	 */
	private filterDataByKikMembers(data: User[], IsKikMember: boolean): void {
		// Fetch Kik members
		this.userService.getKikMembers(IsKikMember).subscribe(
			(kikMembers) => {
				// Fetch Direct customers
				this.userService.getDirectCustomers(this.isDirectCustomer).subscribe(
					(directCustomers) => {
						console.log("directCustomers", directCustomers);
						// Get user ids for Kik members
						const kikMemberUserIds = this.getFilteredUserId(kikMembers);

						// Get user ids for Direct customers
						const directCustomerUserIds = this.getFilteredUserId(directCustomers);
						console.log("directCustomerUserIds", directCustomerUserIds);

						// Combine user ids from both sources
						let filteredUserIds: string[] = kikMemberUserIds.concat(directCustomerUserIds);

						// Filter the data based on the combined user ids
						this.dataSource.data = data.filter((customer) =>
							filteredUserIds.includes(customer.uuid)
						);
					},
					(error) => {
						console.error('Error fetching Direct customers', error);
					}
				);
			},
			(error) => {
				console.error('Error fetching Kik members', error);
			}
		);
	}

	/**
	 * Get filtered usernames based on user role
	 */
	private getFilteredUserId(users: any[]): string[] {
		let filteredUserId: string[] = [];
		if (users !== null) {
			filteredUserId = users.map((user) => user.uuid);
		}
		return filteredUserId;
	}
	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(el => el.unsubscribe());
		// this.socket.disconnect();
	}

	/**
	 * Load users list
	 */
	loadUsersList() {
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize
		);
		this.store.dispatch(new UsersPageRequested({ page: queryParams }));
		this.selection.clear();
	}

	/** FILTRATION */
	filterConfiguration(): any {
		const filter: any = {};
		const searchText: string = this.searchInput.nativeElement.value;

		filter.lastName = searchText;

		filter.username = searchText;
		filter.email = searchText;
		filter.fillname = searchText;
		return filter;
	}

	/** ACTIONS */
	/**
	 * Delete user
	 *
	 * @param _item: User
	 */
	deleteUser(_item: User) {
		const _title = 'User Delete';
		const _description = 'Are you sure to permanently delete this user?';
		const _waitDesciption = 'User is deleting...';
		const _deleteMessage = `User has been deleted`;

		const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
		dialogRef.afterClosed().subscribe(res => {



			if (!res) {
				return;
			}

			this.store.dispatch(new UserDeleted({ id: _item.id }));
			this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete);
		}





		);






	}

	/**
	 * Fetch selected rows
	 */
	fetchUsers() {
		const messages = [];
		this.selection.selected.forEach(elem => {
			messages.push({
				text: `${elem.fullname}, ${elem.email}`,
				id: elem.id.toString(),
				status: elem.username
			});
		});
		this.layoutUtilsService.fetchElements(messages);
	}

	/**
	 * Check all rows are selected
	 */
	isAllSelected(): boolean {
		const numSelected = this.selection.selected.length;
		const numRows = this.usersResult.length;
		return numSelected === numRows;
	}

	/**
	 * Toggle selection
	 */
	masterToggle() {
		if (this.selection.selected.length === this.usersResult.length) {
			this.selection.clear();
		} else {
			this.usersResult.forEach(row => this.selection.select(row));
		}
	}

	/* UI */
	/**
	 * Returns user roles string
	 *
	 * @param user: User
	 */
	getUserRolesStr(user: User): string {
		const titles: string[] = [];
		each(user.roles, (roleId: number) => {
			const _role = find(this.allRoles, (role: Role) => role.id === roleId);
			if (_role) {
				titles.push(_role.title);
			}
		});
		return titles.join(', ');
	}

	/**
	 * Redirect to edit page
	 *
	 * @param id
	 */
	editUser(id) {
		this.router.navigate(['../users/edit', id], { relativeTo: this.activatedRoute });
	}
	applyFilter(filterValue: string) {
		filterValue = filterValue.trim().toLowerCase();
		this.dataSource.filter = filterValue;
	}
	@HostListener('window:beforeunload', ['$event'])
	beforeUnloadHandler(event: Event) {
		// Call logoutUser when the tab or browser is closed
		if (this.userid) {
			this.userService.logoutUser();
		}
	}
	handleImageError(user: User) {
		// If there's an error loading the image or the profilePicture is not available
		if (user && !user.profilePicture) {
			// Set a default image URL using the user's full name
			user.profilePicture = 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user.fullname.charAt(0)) + '&background=random';
		}
	}

}
